/*
 * @Author: whb
 * @Date: 2023-01-06 17:52:02
 * @LastEditors: whb
 * @LastEditTime: 2023-01-06 18:02:12
 * @Description: Do not edit
 */
import axios from "./axios";
import qs from "qs";
function paramFormat (data = {}) {
  const result = {};
  const time = Date.now();
  /* 0 app内部进入 1 外部浏览进入 */
  Object.assign(result, {
    time,
    ...data
  });
  return result;
}
export const axiosUtils = (
  url,
  data = {},
  { method = "get", headers = {}, formData = false, preParams = null, timeout = 15000 } = {}
) => {
  data = (!formData && paramFormat(data)) || data;
  const params =
    method === "get" ? { params: data } : preParams ? { data: preParams } : { data: (!formData && qs.stringify(data)) || data }; // :qs.stringify(data)
  axios.defaults.withCredentials = true;

  return axios({
    method,
    url,
    headers,
    timeout,
    ...params
  });
}